module.exports = __webpack_public_path__ + "static/media/emailicon.2c9fd586.png";